import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

class Localize extends Component {

  createMarkup(stringToMarkup){
    const { breakType, replaceWith } = this.props;

    let stringWithSubstitutions = stringToMarkup.replace(/__/g, replaceWith || '');

    if(breakType === 'paragraph'){
      let paragraphedString = stringWithSubstitutions.replace(/\|/g, '<br/><br/>');
      return <span dangerouslySetInnerHTML={{__html: paragraphedString}}></span>
    }
    else if(breakType === 'steps'){
      let stepItems = stringWithSubstitutions.split('|');
      return (
        <React.Fragment>
          {_.map(stepItems, (item, index) => {
            return <span className="localized-step" key={`item-${index}`}>{item}</span>
          })}
        </React.Fragment>
      );
    }
    else if(breakType === 'list'){
      let listItems = stringWithSubstitutions.split('|');
      return (
        <React.Fragment>
          {_.map(listItems, (item, index) => {
            return <li key={`item-${index}`}>{item}</li>
          })}
        </React.Fragment>
      );
    }
    else if(breakType === 'dot'){
      let dotSeparatedString = stringWithSubstitutions.replace(/\|/g, '&nbsp;&middot;&nbsp;');
      return <span dangerouslySetInnerHTML={{__html: dotSeparatedString}}></span>
    }
    else{
      //default to paragraph style
      let paragraphedString = stringWithSubstitutions.replace(/\|/g, '<br/><br/>');
      return <span dangerouslySetInnerHTML={{__html: paragraphedString}}></span>
    }
  }

  render(){

    const DEFAULT_MISSING_LOCALIZATION_TEXT = "Missing Localization";

    // console.log('Localize re-render with props: ', this.props);

    if(!this.props.activeLocalization && !this.props.locale){
      return this.props.children || DEFAULT_MISSING_LOCALIZATION_TEXT;
    }
    else{
      let localizeKeysToCheck = [];
      let localizationSourcesToCheck = [];

      if(this.props.ids){
        localizeKeysToCheck = this.props.ids;
      }
      else if(this.props.id){
        localizeKeysToCheck.push(this.props.id);
      }

      //if superadmin, highest priority localizations source = locale specified
      if(this.props.locale && this.props.allLocalizations[this.props.locale]){
        localizationSourcesToCheck.push(this.props.allLocalizations[this.props.locale])
      }
      if(this.props.activeLocalization){
        localizationSourcesToCheck.push(this.props.activeLocalization);
      }

      //all keys and sources setup, now start looking for matching localizations...
      let matchingLocalizationForKey = false;
      _.each(localizationSourcesToCheck, source => {
        _.each(localizeKeysToCheck, key => {
          if(!matchingLocalizationForKey){
            if(source[key]){
              matchingLocalizationForKey = source[key];
            }
          }
        });
      });

      if(matchingLocalizationForKey){
        return this.createMarkup(matchingLocalizationForKey)
      }
      else if(this.props.hideIfMissing){
        return "";
      }
      else if(this.props.children){
        return this.props.children;
      }
      else{
        console.log(`Missing localization entirely for ${localizeKeysToCheck}`);
        return DEFAULT_MISSING_LOCALIZATION_TEXT;
      }
    }
  }
}

const mapStateToProps = state => {
  return {
    activeLocalization: state.activeLocalization.data,
    allLocalizations: state.allLocalizations.data,//for superadmins
  }
}

export default connect(mapStateToProps, {})(Localize);



// WEBPACK FOOTER //
// ./src/components/shared/localize.js